import { render, staticRenderFns } from "./SpecOutStatus.vue?vue&type=template&id=28070e16&"
import script from "./SpecOutStatus.vue?vue&type=script&lang=ts&"
export * from "./SpecOutStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports